module.exports = __webpack_public_path__ + "img/icon-submit-mew.bf286d01.svg";